module.exports = __webpack_public_path__ + "img/left-leg_hover.3b55ad20.png";